import {ThatsMeLoadingButton} from "../buttons/thatsMeLoadingButton";
import {Search} from "@carbon/icons-react";
import {AutocompleteInput} from "../form/autocomplete.input";
import {Celebrity} from "../../common/models/celebrity/celebrity";
import CelebrityAutocompleteOption from "./celebrityAutocompleteOption";
import {Stack, useTheme} from "@mui/material";
import React, {useState} from "react";
import CelebritySearchModal from "../modals/celebritySearch.modal";
import {searchCelebrity} from "../../api/celebrityService";
import {ErrorHelper} from "../../common/utils/error.helper";
import {AxiosError} from "axios";
import {useForm} from "react-hook-form";
import {useIsMobile} from "../../common/hooks/useIsMobile";
import {FixedRoute} from "../../common/enums/route.enum";
import {useDebounce} from "../../common/hooks/useDebounce";

const CelebritySearchField = () => {

    const isMobile = useIsMobile();
    const theme = useTheme();
    const [openModal, setOpenModal] = useState(false);
    const [options, setOptions] = useState<Celebrity[]>([]);

    const {
        control,
    } = useForm();

    const handleOpenSearchModal = () => {
        setOpenModal(true);
    };

    const handleCloseSearchModal = () => {
        setOpenModal(false);
    };

    const getCelebrities = async (value: string) => {
        try {
            const response = await searchCelebrity(value, 1, 50);

            return response?.results;
        } catch (error) {
            console.error(error);
            ErrorHelper.showErrors(error as AxiosError);
        }
    };

    const generateAutocompleteOptions = async(searchTerm: string) => {
        const autocompleteOptions = await getCelebrities(searchTerm);
        setOptions(autocompleteOptions?? []);
    };
    
    const onSelected = (value: unknown) => {
        const celebrity = value as Celebrity;
        
        if(!celebrity) {
            return;
        }

        window.location.assign(`/${FixedRoute.CompatibilityCelebrity}/${celebrity.id}`);
    };

    const onInputChange = useDebounce((value?: string | null) => {
        if(!value) {
            setOptions([]);
            return;
        }

        void generateAutocompleteOptions(value);
    }, 200);

    return (
        <Stack width={'100%'}>
            {
                isMobile ?
                    <ThatsMeLoadingButton variant={"mockInputField"} onClick={handleOpenSearchModal}>
                        <Search size={26} fill={theme.palette.thatsMe.iconsButton} /> Search celebrities
                    </ThatsMeLoadingButton>
                    :
                    <AutocompleteInput
                        placeholder={"Search celebrities"}
                        control={control}
                        onInputChangeMethod={onInputChange}
                        disableFilteringOption
                        hideEndAdornment
                        name={"celebrity"}
                        items={options as Celebrity[]}
                        onSelected={onSelected}
                        RenderItemOption={(c) =>
                            <CelebrityAutocompleteOption celebrity={c as Celebrity}/>
                        }
                        getOptionLabel={(c) =>  (c as Celebrity).fullName}
                        getOptionValue={(c) => (c as Celebrity).id}
                        fieldMapper={(value, items) => items.find((c) => value === c)}
                        valueMapper={(value, items) => value}
                    />
            }
            <CelebritySearchModal openModal={openModal} onClose={handleCloseSearchModal}/>
        </Stack>
    );
};

export default CelebritySearchField;